export const secretIv = '1234567890123456' // 密钥偏移量
export const secretKey = 'IWPAX9g6oEe1rLas' // 密钥
export const runse = '润色'
export const kuoxie = '扩写'
export const suoxie = '缩写'
export const xiugai = '修改'
export const chtoen = '中/英'
export const chongxie = '重写'
export const aigc = '降AIGC'
export const chnEn = '中/外'
export const model = 'GPT-5-db'
export const model_4_db = 'GPT-4.1-db'
export const model_4 = 'GPT-4.1'
export const deepseekModel = 'DeepSeek-Chat' // DeepSeek-V3
export const DEAL_ICON = ['icon-arrowLeft', 'icon-arrowRight', 'icon-jia', 'icon-bianji', 'icon-lajitong']
export const DEAL_ICON_2 = ['icon-arrowLeft', 'icon-arrowRight', 'icon-jia', 'icon-edit', 'icon-lajitong']
export const author = '学校 - 专业 - 姓名'
export const link = 'www.aiunipaper.com'
export const err1 = '文件解析错误，请重试或联系客服处理'
export const err2 = '论文导出错误，请重试或联系客服处理'
export const STRERR = ['paragraph', 'translation', 'content', 'keywords']
export const FREE_COUNT = 3
export const ECHART_SCALE = 0.5
import imageMap from '@/components/loadChartImages'
export const digtToChinese: any = {
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '七',
  8: '八',
  9: '九',
  10: '十',
  11: '十一',
  12: '十二',
  13: '十三',
  14: '十四',
  15: '十五',
  16: '十六',
  17: '十七',
  18: '十八',
  19: '十九',
  20: '二十',
  21: '二十一',
  22: '二十二',
  23: '二十三',
  24: '二十四',
  25: '二十五',
  26: '二十六',
  27: '二十七',
  28: '二十八',
  29: '二十九',
  30: '三十',
  31: '三十一',
  32: '三十二',
  33: '三十三',
  34: '三十四',
  35: '三十五',
  36: '三十六',
  37: '三十七',
  38: '三十八',
  39: '三十九',
  40: '四十',
  41: '四十一',
  42: '四十二',
  43: '四十三',
  44: '四十四',
  45: '四十五',
  46: '四十六',
  47: '四十七',
  48: '四十八',
  49: '四十九',
  50: '五十',
  51: '五十一',
  52: '五十二',
  53: '五十三',
  54: '五十四',
  55: '五十五',
  56: '五十六',
  57: '五十七',
  58: '五十八',
  59: '五十九',
  60: '六十'
}

export const convertTitleToNumber: any = {
  第一章: '1',
  第二章: '2',
  第三章: '3',
  第四章: '4',
  第五章: '5',
  第六章: '6',
  第七章: '7',
  第八章: '8',
  第九章: '9',
  第十章: '10',
  第十一章: '11',
  第十二章: '12',
  第十三章: '13',
  第十四章: '14',
  第十五章: '15',
  第十六章: '16',
  第十七章: '17',
  第十八章: '18',
  第十九章: '19',
  第二十章: '20',
  第二十一章: '21',
  第二十二章: '22',
  第二十三章: '23',
  第二十四章: '24',
  第二十五章: '25',
  第二十六章: '26',
  第二十七章: '27',
  第二十八章: '28',
  第二十九章: '29',
  第三十章: '30'
}

export const AUTO_ECHART_DESC =
  '折线图、柱状图、折柱混合图、扇形图、散点图、雷达图等最适合（优先使用折线图堆叠、折柱混合图、扇形图）'
export const ECHART_TYPE = [
  {
    value: AUTO_ECHART_DESC,
    label: '智能生成',
    icon: 'icon-auto',
    exec: null,
    img: null
  },
  { value: '折线图', label: '折线图', icon: 'icon-chartline', img: imageMap['chartline'], exec: null },
  { value: '柱状图', label: '柱状图', icon: 'icon-chartcolumn', img: imageMap['chartcolumn'], exec: null },
  { value: '折柱混合图', label: '折柱混合图', icon: 'icon-zhezhuhunhetu', img: imageMap['zhezhuhunhetu'], exec: null },
  { value: '扇形图', label: '扇形图', icon: 'icon-shanxingtu', img: imageMap['shanxingtu'], exec: null },
  { value: '散点图', label: '散点图', icon: 'icon-chartscatter', img: imageMap['chartscatter'], exec: null },
  { value: '雷达图', label: '雷达图', icon: 'icon-leidatu', img: imageMap['leidatu'], exec: null },
  { value: '流程图', label: '流程图', icon: 'icon-liuchengtu', img: imageMap['liuchengtu'], exec: 'flow' },
  { value: '思维导图', label: '思维导图', icon: 'icon-icon-siweidaotu', img: imageMap['siweidaotu'], exec: 'mind' },
  { value: '时序图', label: '时序图', icon: 'icon-shixutu2', img: imageMap['shixutu2'], exec: 'sequence' },
  { value: '甘特图', label: '甘特图', icon: 'icon-gantetu', img: imageMap['gantetu'], exec: 'gant' },
  { value: '类图', label: '类图', icon: 'icon-gezicofbuguizefenzu1', img: imageMap['gezicofbuguizefenzu1'], exec: 'class' },
  { value: '状态图', label: '状态图', icon: 'icon-zhuangtaitu', img: imageMap['zhuangtaitu'], exec: 'state' },
  { value: '实体关系图（ER图）', label: 'ER图', icon: 'icon-ER-Graph', img: imageMap['ER'], exec: 'er' },
  // { value: '象限图', label: '象限图', icon: 'icon-sixiangxiantu', img: imageMap['sixiangxiantu'], exec: },
  // { value: '需求图', label: '需求图', icon: 'icon-xuqiutu', img: imageMap['xuqiutu'], exec: },
  { value: '架构图', label: '架构图', icon: 'icon-ETLzuixin', img: imageMap['ETLzuixin'], exec: 'frame' },
  { value: 'ZenUML图', label: 'ZenUML图', icon: 'icon-UML', img: imageMap['UML'], exec: 'uml' }
  // { value: '数据包图', label: '数据包图', icon: 'icon-shujubao', img: imageMap['shujubao'], exec: }
]

const desc = '对json数据结构要求：'
export const ECHART_TO_DESC: any = {
  折线图:
    desc +
    '“json中最外层必须包含xAxis、yAxis, xAxis中需包含data字段（对横坐标的说明），series中的data只需返回具体数值的一维数组即可。”',
  柱状图:
    desc +
    '“json中最外层必须包含xAxis、yAxis, xAxis中需包含data字段（对横坐标的说明），series中的data只需返回具体数值的一维数组即可。”',
  扇形图: desc + '“series数组中只需包含一条数据（即一个扇形图数据，不可返回多个扇形图数据）。”',
  折柱混合图:
    desc +
    '“json中最外层必须包含xAxis、yAxis, xAxis中需包含data字段（对横坐标的说明），series中的data只需返回具体数值的一维数组即可。”',
  散点图:
    desc +
    '“json中最外层必须包含xAxis、yAxis, xAxis中必须包含data字段（对横坐标的说明），series中的data只需返回具体数值的一维数组即可。”',
  雷达图: desc + '“json中最外层必须包含radar对象。indicator对象要放在radar对象中，不可放在series.data中。”',
  流程图: desc + '',
  思维导图: desc + '',
  时序图: desc + '',
  甘特图: desc + '',
  类图: desc + '',
  状态图: desc + '',
  '实体关系图（ER图）': '',
  象限图: '',
  需求图: '',
  架构图: '',
  ZenUML图: '',
  数据包图: ''
}
// 生成对象映射
export const ECHART_TYPE_MAP = Object.fromEntries(ECHART_TYPE.map(({ value, icon }) => [value, icon]))
export const ECHART_TYPE_LIST = ECHART_TYPE.slice(0, 7).map(item => item.value)
export const MERMIAD_TYPE_LIST = ECHART_TYPE.slice(7).map(item => item.value)
export const MORE_ICON = ECHART_TYPE.map(({ label, icon, img, value, exec }) => {
  return {
    icon,
    label: label == 'ZenUML图' ? 'UML图' : label,
    img,
    value,
    exec
  }
})
const IMGS = [
  'https://cos.aiunipaper.com/files/chart_1_2.png',
  'https://cos.aiunipaper.com/files/chart_1_3.png',
  'https://cos.aiunipaper.com/files/chart_1_1.png',
  'https://cos.aiunipaper.com/files/chart_1_4.png',
  'https://cos.aiunipaper.com/files/chart_1_5.png',
  'https://cos.aiunipaper.com/files/chart_1_6.png',
  'https://cos.aiunipaper.com/files/chart_1_7.png',
  'https://cos.aiunipaper.com/files/chart_1_8.png',
  'https://cos.aiunipaper.com/files/chart_1_9.png',
  'https://cos.aiunipaper.com/files/chart_1_10.png',
  'https://cos.aiunipaper.com/files/chart_1_11.png',
  'https://cos.aiunipaper.com/files/chart_1_12.png',
  'https://cos.aiunipaper.com/files/chart_1_13.png',
  'https://cos.aiunipaper.com/files/chart_1_14.png',
  'https://cos.aiunipaper.com/files/chart_1_15.png'
]
export const FILTER_ICON = ECHART_TYPE.filter((item, index) => index != 0)
export const INDEX_ICON = (() => {
  const arr = FILTER_ICON.map(({ label, icon, value, exec }, index) => ({
    icon,
    label: label === 'ZenUML图' ? 'UML图' : label,
    img: IMGS[index],
    value,
    exec
  }))
  // 交换 0 和 2
  ;[arr[0], arr[2]] = [arr[2], arr[0]]
  return arr
})()
export const ECHART_TIYLE = {
  // title: {
  left: 'center',
  top: '5px'
  // }
}
export const ECHARTS_OPTION = {
  legend: {
    top: '40px'
  },
  grid: {
    left: '5%',
    right: '5%',
    top: '25%',
    bottom: '5%',
    containLabel: true
  },
  toolbox: {
    show: false
  }
}

export const PIE = {
  radius: ['25%', '50%'],
  center: ['50%', '55%'],
  itemStyle: {
    borderRadius: 8,
    borderColor: '#fff',
    borderWidth: 5
  },
  emphasis: {
    label: {
      show: true,
      fontSize: '14',
      fontWeight: 'bold'
    }
  },
  label: {
    show: true,
    formatter: '{b}  {c}  {d}%'
  },
  labelLine: {
    show: true
  }
}
export const RADAR = {
  radar: {
    center: ['50%', '60%']
  },
  label: {
    show: true,
    position: 'top'
  }
}
export const NO_PIE = {
  emphasis: {
    label: {
      show: true,
      fontSize: '14',
      fontWeight: 'bold'
    }
  },
  label: {
    show: true,
    position: 'top'
  }
}
export const DEAL_TIP: any = {
  0: '提升标题级别',
  1: '降低标题级别',
  2: '在下方插入新标题',
  3: '手动修改标题内容',
  4: '删除标题'
}
// 生成正文段落时生效
// export const DEAL_TIP_2: any = [
//   { tip: ['关联参考文献', '下次生成段落时生效'], value: 0, icon: 'icon-fuhao_biaodian_zhongkuohao' },
//   { tip: ['段落插入表格', '下次生成段落时生效'], value: 1, icon: 'icon-biaoge' },
//   { tip: ['段落插入公式', '下次生成段落时生效'], value: 2, icon: 'icon-formula' },
//   { tip: ['段落插入代码', '下次生成段落时生效'], value: 3, icon: 'icon-code' },
//   { tip: ['段落插入图表', '下次生成段落时生效'], value: 4, icon: 'icon-chartcolumn' }
// ]

export const DEAL_TIP_3: any = [
  { tip: ['段落插入表格', '生成正文段落时生效'], value: 1, icon: 'icon-biaoge' },
  { tip: ['段落插入公式', '生成正文段落时生效'], value: 2, icon: 'icon-formula' },
  { tip: ['段落插入代码', '生成正文段落时生效'], value: 3, icon: 'icon-code' },
  { tip: ['段落插入图表', '生成正文段落时生效'], value: 4, icon: 'icon-chartcolumn' }
]
export const LANG_LIST = [
  { label: '中' },
  { label: '英' },
  { label: '法' },
  { label: '德' },
  { label: '日' },
  { label: '韩' },
  { label: '泰' },
  { label: '俄' }
]
export const NO_DEL_LEVEL_TITLE = ['摘要', '关键词', 'Abstract', 'KeyWords', '致谢', '参考文献', '研究进度计划']
export const UNIT: any = {
  0: '份',
  1: '篇',
  2: '篇',
  3: '篇',
  4: '篇',
  5: '份',
  6: '千字',
  7: '千字',
  8: '篇'
}
